export const APPROVAL_REQUEST_ANALYTICS_EVENTS = {
  APPROVAL_REQUEST_LIST_FETCH: "approval-request-list-fetch",
  APPROVAL_REQUEST_DETAIL_FETCH: "approval-request-detail-fetch",
  APPROVAL_REQUEST_ACTION: "approval-request-action",
  APPROVAL_REQUEST_OVERRIDE: "approval-request-override",
  APPROVAL_REQUEST_CANCEL: "approval-request-cancel",
};

export const APPROVAL_DELEGATION_ANALYTICS_EVENTS = {
  LIST_FETCH: "approval-delegation-list-fetch",
  ASSIGNED_LIST_FETCH: "approval-delegation-assigned-list-fetch",
  CREATE: "approval-delegation-create",
  UPDATE: "approval-delegation-update",
  DELETE: "approval-delegation-delete",
  DIALOG_OPEN: "approval-delegation-dialog-open",
  EDIT_OPEN: "approval-delegation-edit-open",
};
